import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/logo_new2.png';
import _imports_1 from '../../assets/search.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-d22066d2"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "tabs"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "search"
  }), /*#__PURE__*/_createElementVNode("div", {
    class: "tabbar"
  })], -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.active == 1 ? 'head2' : 'head'),
    style: _normalizeStyle(_ctx.styleObject)
  }, [_createElementVNode("img", {
    src: _imports_0,
    class: "logo",
    onClick: _cache[0] || (_cache[0] = function () {
      return _ctx.handleHome && _ctx.handleHome.apply(_ctx, arguments);
    })
  }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
    class: "tab",
    onClick: _cache[1] || (_cache[1] = function () {
      return _ctx.handleHome && _ctx.handleHome.apply(_ctx, arguments);
    })
  }, [_createElementVNode("div", {
    class: _normalizeClass(_ctx.active == 0 ? 'title_active' : 'title')
  }, "官网首页", 2), _createElementVNode("div", {
    class: _normalizeClass(_ctx.active == 0 ? 'tabbar_active' : 'tabbar')
  }, null, 2)]), _createElementVNode("div", {
    class: "tab",
    onClick: _cache[2] || (_cache[2] = function () {
      return _ctx.handleProduct && _ctx.handleProduct.apply(_ctx, arguments);
    })
  }, [_createElementVNode("div", {
    class: _normalizeClass(_ctx.active == 1 ? 'title_active' : 'title')
  }, "产品中心", 2), _createElementVNode("div", {
    class: _normalizeClass(_ctx.active == 1 ? 'tabbar_active' : 'tabbar')
  }, null, 2)]), _createElementVNode("div", {
    class: "tab",
    onClick: _cache[3] || (_cache[3] = function () {
      return _ctx.handleNews && _ctx.handleNews.apply(_ctx, arguments);
    })
  }, [_createElementVNode("div", {
    class: _normalizeClass(_ctx.active == 2 ? 'title_active' : 'title')
  }, "相关资讯", 2), _createElementVNode("div", {
    class: _normalizeClass(_ctx.active == 2 ? 'tabbar_active' : 'tabbar')
  }, null, 2)]), _createElementVNode("div", {
    class: "tab",
    onClick: _cache[4] || (_cache[4] = function () {
      return _ctx.handlePartner && _ctx.handlePartner.apply(_ctx, arguments);
    })
  }, [_createElementVNode("div", {
    class: _normalizeClass(_ctx.active == 3 ? 'title_active' : 'title')
  }, "合作伙伴", 2), _createElementVNode("div", {
    class: _normalizeClass(_ctx.active == 3 ? 'tabbar_active' : 'tabbar')
  }, null, 2)]), _createElementVNode("div", {
    class: "tab",
    onClick: _cache[5] || (_cache[5] = function () {
      return _ctx.handleJoinUs && _ctx.handleJoinUs.apply(_ctx, arguments);
    })
  }, [_createElementVNode("div", {
    class: _normalizeClass(_ctx.active == 4 ? 'title_active' : 'title')
  }, "加入我们", 2), _createElementVNode("div", {
    class: _normalizeClass(_ctx.active == 4 ? 'tabbar_active' : 'tabbar')
  }, null, 2)]), _createElementVNode("div", {
    class: "tab",
    onClick: _cache[6] || (_cache[6] = function () {
      return _ctx.handleAboutUs && _ctx.handleAboutUs.apply(_ctx, arguments);
    })
  }, [_createElementVNode("div", {
    class: _normalizeClass(_ctx.active == 5 ? 'title_active' : 'title')
  }, "关于我们", 2), _createElementVNode("div", {
    class: _normalizeClass(_ctx.active == 5 ? 'tabbar_active' : 'tabbar')
  }, null, 2)]), _hoisted_2])], 6);
}